import * as z from 'zod/v4-mini';
import { AuthProtocol, defineAuthProvider } from '../../../types/auth-providers/define';

export const passwordConfigSchema = z.object({});
export type PasswordConfig = z.infer<typeof passwordConfigSchema>;

/**
 * Built-in password provider. The seeded BE `local` row has empty `config`.
 * No `options` form: this protocol is not admin-configurable per provider.
 *
 * Exists in the registry so that consumers (`useAuth`, login UI) can
 * branch on `protocol === 'password'` against a complete registry.
 */
export const password = defineAuthProvider<PasswordConfig>({
	id: 'password',
	name: '$t:sso_providers.password.name',
	protocol: AuthProtocol.Password,
	icon: 'lucide:key',
	schema: passwordConfigSchema,
});
